import Tableenterprise from './components/enterprisetable/tableenterprise.vue'
import Searchenterprise from './components/searchenterprise/searchenterprise.vue'
import Detailsenterprise from './components/detailsenterprise/detailsenterprise.vue'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  components: {Tableenterprise, Searchenterprise, Detailsenterprise},
  name: 'Enterprise',
  mixins: [ PermissionMixin ],
  data () {
    return {
      title: 'Buscar Empreendimento',
      flDetails: false,
      dataDetails: [],
      dataFilter: [],
      id: null,
      roles: Roles
    }
  },
  mounted () {
  },
  methods: {
    showDetails (obj) {
      this.id = obj.id
      this.$emit('id', this.id)
      this.dataDetails = obj
      this.flDetails = true
    },
    changeDataFilter (obj) {
      this.dataFilter = obj
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/enterprise.js